// utils.js or helper.js

export default {
    formatUrl(url) {
        if (!/^https?:\/\//i.test(url)) {
            return `https://${url}`;
        }
        return url;
    },
    getSiteStatusSeverity(status) {
        switch (status) {
            case 'pending approval':
                return 'secondary';
            case 'approved':
                return 'success';
            case 'rejected':
                return 'danger';
            default:
                return 'danger';
        }
    },
    getAdvertiserMappingSeverity(status) {
        switch (status) {
            case false:
                return 'danger';
            case true:
                return 'success';
            default:
                return 'danger';
        }
    },
    getLinkStatusSeverity(status) {
        switch (status) {
            case 'requested':
                return 'secondary';
            case 'linked':
                return 'success';
            case 'rejected':
                return 'danger';
            default:
                return 'danger';
        }
    }, getSiteTypeSeverity(type) {
        switch (type) {
            case 'social':
                return 'info';
            case 'organic':
                return 'secondary';
            case 'ppc':
                return 'warn';
            case 'seo':
                return 'primary';
            default:
                return 'danger';
        }
    },
    getUserStatusSeverity(status) {
        switch (status) {
            case 'pending kyc':
                return 'secondary';
            case 'approved':
                return 'success';
            case 'rejected':
                return 'danger';
            case 'blocked':
                return 'contrast'
            default:
                return 'danger';
        }
    }
};
